<div class="notify mat-elevation-z10" *ngIf="showNotification">
  <h1>Presale active!
    <button mat-icon-button color="primary" style="bottom: 5px;" (click)="onHide()">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <p>10 klay for random</p>
  <p>cat. <a routerLink="/mint">Mint now!</a></p>
</div>
